
import React from 'react';
import { DatabaseInitializer } from "@/components/admin/DatabaseInitializer";
import { MedicalDataSync } from "@/components/admin/MedicalDataSync";
import { MedicalDataSyncDashboard } from "@/components/admin/MedicalDataSyncDashboard";

const Admin = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-6 py-8">
        <div className="max-w-6xl mx-auto space-y-8">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Medical Database Administration
            </h1>
            <p className="text-gray-600">
              Initialize and manage the medical knowledge base
            </p>
          </div>

          <MedicalDataSyncDashboard />
          
          <DatabaseInitializer />
          
          <MedicalDataSync />
        </div>
      </div>
    </div>
  );
};

export default Admin;
